import React from 'react';
import { useNavigate } from 'react-router-dom';
import { AppShell, PageHeader } from '@/components/AppShell';
import { FamilyModeAdmin } from '@/components/FamilyModeAdmin';
import { ShieldCheck, ChevronLeft } from 'lucide-react';

export default function Admin() {
  const navigate = useNavigate();
  return (
    <AppShell>
      <PageHeader
        title="Admin"
        subtitle="Private controls"
        right={(
          <button onClick={() => navigate('/app')} data-testid="admin-back-button" className="inline-flex items-center gap-1 text-sm font-semibold" style={{ color: 'var(--primary)' }}>
            <ChevronLeft size={16} /> App
          </button>
        )}
      />
      <div className="rounded-2xl p-4 border mb-4" style={{ background: 'var(--surface)', borderColor: 'var(--border)' }} data-testid="admin-page">
        <div className="flex items-center gap-2 mb-3">
          <ShieldCheck size={18} style={{ color: 'var(--primary)' }} />
          <h2 className="font-bold" style={{ color: 'var(--text)' }}>KilalaRide controls</h2>
        </div>
        <p className="text-sm mb-4" style={{ color: 'var(--text-muted)' }}>
          Use your passcode to manage production feature flags.
        </p>
        <FamilyModeAdmin />
      </div>
    </AppShell>
  );
}
